export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const SEND_EMAIL = "SEND_EMAIL";
export const GET_EMAIL_HISTORY = "GET_EMAIL_HISTORY";